import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';

import BaseDialogContainer from '../../baseContainers/BaseDialogContainer';
import ActionButton from '../../components/ActionButton';
import DivContainer from '../../components/DivContainer';
import UserAbsenceReasonService from '../../services/UserAbsenceReasonService';
import InputTextComponent from '../../components/inputs/InputTextComponent';

class EmployeeAbsenceReasonEditDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new UserAbsenceReasonService());
        this.state = {
            elementId: props.elementId,
            element: {
                reason: '',                
                status: {enumValue: 'ACTIVE', label: 'Aktywny'},
            },
            viewMode: this.props.viewMode,
        };
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <div className='left-footer-dialog-button-container'></div>
                <ActionButton
                    label={t('details.cancel')}
                    variant={'button cancel-button white'}
                    handleClick={(e) => {
                        this.props.onHide(undefined);
                    }}
                />
                <ActionButton
                    label={this.state.viewMode === 'NEW' ? t('employee.absence.addButton') : t('details.saveChanges')}
                    variant='button save-button blue'
                    handleClick={this.handleFormSubmit}
                    rendered={this.state.viewMode !== 'DELETE'}
                />
            </div>
        );
    }
   
    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12'>
                <DivContainer colClass='col-12'>
                    <label>
                        {this.state.viewMode === 'NEW'
                            ? `${t('employee.absence.addHeader')}`
                            : this.state.viewMode === 'EDIT'
                            ? `${t('employee.absence.editHeader')}`
                            : this.state.viewMode === 'DELETE'
                            ? `${t('employee.absence.deleteHeader')}`
                            : null}
                    </label>
                </DivContainer>
            </DivContainer>
        );
    }
    updateElement(data) {
        this.setState(
            {
                element: data,
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }
    setElement() {
        if (this.props.element) {
            this.updateElement(this.props.element);
        }
    }

    getAddSucces() {
        const {t} = this.props;
        return t('employee.absence.addSuccess');
    }
  
    getUpdateSucces() {
        const {t} = this.props;
        return t('employee.absence.updateSuccess');
    }
    createOrUpdate() {
        const {element} = this.state;
        this.scrollToTop();
        if (this.props._isMounted) {
            if (element.id === undefined || element.id === null) {
                this.service
                    .add(element)
                    .then((response) => {
                        this.blockUi();
                        this.persistMessage('success', '', this.getAddSucces(response));
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.message);
                        this.unblockUi();
                    });
            } else {
                this.service
                    .update(element)
                    .then((response) => {
                        this.blockUi();
                        this.persistMessage('success', '', this.getUpdateSucces(response));
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.message);
                        this.unblockUi();
                    });
            }
        }
    }

    renderDetails() {
        return  (
            <React.Fragment>
                <DivContainer colClass='row'>
                <InputTextComponent
                    id='reason'
                    name='reason'
                    label={'Powód'}
                    colClass='col-md-12'
                    value={this.state.element.reason}
                    validator={this.validator}
                    validators='required|max:30'
                    onChange={this.handleChange}
                    viewMode={'EDIT'}                        
                 />
                </DivContainer>
            </React.Fragment>
        );
    }
}

EmployeeAbsenceReasonEditDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    visible: false,
    stationId: undefined,
};

EmployeeAbsenceReasonEditDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    elementId: PropTypes.number,
    stationId: PropTypes.number,
    roleTypes: PropTypes.object,
    className: PropTypes.string
};

export default withTranslation()(EmployeeAbsenceReasonEditDialog);
